
import { defineComponent } from "vue";

export default defineComponent({
  name: "PaydownStatBlock",
  props: {
    type: {
      type: String,
      default: "text",
      validator: (value: string) => ["text", "progress"].includes(value)
    },
    value: {
      required: true,
      default: ""
    },
    title: {
      type: String,
      required: true,
      default: ""
    }
  }
});
